import styled, { css ,keyframes} from 'styled-components';
import breakpoint, { map } from 'styled-components-breakpoint';

const moveFromLeft = keyframes`
  0% {
    transform: translateX(-9rem);

  }

  100% {
    transform: translateX(0);
  }
 ` 

 
const nullify = keyframes`
0% {
  transform: translateX(0);

}

` 

export const Rating = styled.div`
    margin-top: 2.5rem;
    display: none;
    animation: ${moveFromLeft} .6s;

    ${breakpoint('xs','md')`  
    display: none;  
    animation: ${nullify} .1s;

    `}



`

export const Icon = styled.div`
    margin-top: 2.5rem;

`

export const Card = styled.div`
        display: flex; 
        flex-direction: column;
        align-items: center;
        height: auto;
        width: 25rem;
        background-color: #f7f7f7;
        border-radius: 3px;
        padding: 2rem 0;

        &:hover ${Rating}{
            display: none;
            
        }

       
        &:hover ${Icon}{
           // display:none;
            ${breakpoint('xs','md')`  
            display: block;  
            `}

           
        }

        
        

`

export const Language = styled.h2`
    font-size: 2rem;
    font-family: Lato;
    font-weight: 400;
    -webkit-background-clip: text;
    color: transparent;
    letter-spacing: 2px; 
    background-image: linear-gradient(to right bottom,#606c88, #3f4c6b);
 

`


// background-image: linear-gradient(to right bottom,#606c88, #3f4c6b);
